import type { Messages } from './es';

/** Diccionario en inglés, tipado contra el español: no puede faltarle una clave. */
export const en: Messages = {
  appName: 'Miyuki',

  newDesign: 'New design',
  columns: 'Columns',
  colors: 'Colors',
  create: 'Create',
  untitledDesign: 'Untitled',
  columnsOutOfRange: 'Width must be between 1 and 30 columns',
  colorsOutOfRange: 'Colors must be between 1 and 99',

  canvasLabel: 'Design canvas',
  canvasDescription: 'Bracelet grid. Tap a cell to place a bead.',
  rowNumber: 'Row {n}',

  palette: 'Palette',
  eraser: 'Eraser',
  editColor: 'Edit color',
  addColor: 'Add color',
  colorLimitReached: 'You declared {n} colors and they are all in use.',
  raiseColorLimit: 'Raise to {n}?',
  maxColorsReached: 'A design cannot go beyond 99 colors.',
  removeColor: 'Remove color',
  reassignBeadsTitle: 'Which color should these beads become?',
  reassignBeadsBody: '{n} beads use this color.',
  leaveEmpty: 'Leave empty',

  addRow: 'Add row',
  insertRowAbove: 'Insert row above',
  duplicateRow: 'Duplicate row',
  removeRow: 'Delete row',
  maxRowsReached: 'A design cannot go beyond 500 rows.',
  rowActions: 'Row {n} actions',

  resizeColumns: 'Change width',
  beadsWillBeLost: '{n} beads will be lost.',

  undo: 'Undo',
  redo: 'Redo',

  save: 'Save',
  saveAs: 'Save as',
  designName: 'Design name',
  myDesigns: 'My designs',
  open: 'Open',
  rename: 'Rename',
  duplicate: 'Duplicate',
  delete: 'Delete',
  noDesignsYet: "You haven't saved any designs yet.",
  designMeta: '{columns} col · {rows} rows · {date}',

  nameTakenTitle: 'That name already exists',
  nameTakenBody: 'A design called “{name}” already exists. Replace it?',
  replace: 'Replace',

  confirmDeleteTitle: 'Delete this design?',
  confirmDeleteBody: '“{name}” will be removed from this device and cannot be recovered.',

  unsavedChangesTitle: 'You have unsaved changes',
  unsavedChangesBody: 'If you continue, you will lose everything since your last save.',
  discardChanges: 'Discard changes',

  resumeDraftTitle: 'You have an unsaved design',
  resumeDraftBody: 'You left a design unfinished last time. Want to pick it up?',
  resume: 'Resume',
  discard: 'Discard',

  saveFailedQuota: 'There is no room left in this browser to save this design.',
  saveFailedUnavailable: 'This browser does not allow saving designs.',
  loadFailedCorrupt: 'This design is damaged and cannot be opened.',

  // Design settings
  settings: 'Design settings',
  apply: 'Apply',
  resizeColumnsTitle: 'Change the width?',

  // Framing
  fitToScreen: 'View all',
  moreRowsAbove: 'More rows above',
  moreRowsBelow: 'More rows below',

  // Pattern type
  patternType: 'Pattern type',
  patternTypeLoom: 'Straight grid',
  patternTypePeyote: 'Staggered',
  patternTypeLoomHint: 'Every bead sits right above the one below (loom).',
  patternTypePeyoteHint: 'Each row shifts by half a bead (peyote).',

  // Tracking mode
  trackingStart: 'Follow the weave',
  trackingExit: 'Back to design',
  trackingPosition: 'Row {n} of {total}',
  trackingPercent: '{n}%',
  trackingRowsRemaining: '{n} rows to go',
  trackingRowsRemainingOne: '1 row to go',
  trackingBeadsRemaining: '{n} beads left to thread',
  trackingCompleteRow: 'Row done',
  trackingUndo: 'Undo progress',
  trackingRedo: 'Redo progress',
  trackingGoToRow: 'Go to a row',
  trackingGoToRowLabel: 'Row number',
  trackingGoToRowInvalid: 'The design has {total} rows',
  trackingReset: 'Start over',
  trackingResetTitle: 'Start over?',
  trackingResetBody: 'Progress goes back to row 1. The design is unchanged.',
  trackingFinished: 'Bracelet finished',
  trackingFinishedBody: 'All {total} rows are woven.',
  trackingSummary: 'Beads in row {n}',
  trackingGap: 'Gap',
  trackingGapCount: '{n} with no bead',
  trackingColorOrdinal: 'Colour {n}',
  trackingRunCount: '{n} × colour {color}',
  trackingFromRight: 'Thread from right to left',
  trackingFromLeft: 'Thread from left to right',
  trackingAlternates: 'Alternate direction row by row',
  trackingAlternatesHint: 'When a row ends the thread sits on the other side.',

  // Menu and guide
  menu: 'Menu',
  quickGuide: 'Quick guide',
  guidePanTitle: 'Move the design',
  guidePanBody: 'Drag with two fingers. One finger paints, so the canvas stays put.',
  guideZoomTitle: 'Zoom in and out',
  guideZoomBody:
    'Pinch with two fingers. The "View all" button brings the whole design back on screen.',
  guideSaveTitle: 'Saving',
  guideSaveBody:
    'The dot next to the name means unsaved changes. "Save", in this menu, stores them under a name.',
  guideNewDesignTitle: 'Starting a design',
  guideNewDesignBody:
    '"New design" asks for the width, how many colours it will use and the pattern type.',
  guidePaletteTitle: 'Colours',
  guidePaletteBody:
    'Tap a colour to pick it, tap it again to change or remove it. The "+" button adds one more.',
  guideRowsTitle: 'Rows',
  guideRowsBody:
    '"Add row" appends one at the end. Tapping a row number offers inserting above, duplicating or deleting.',
  guidePatternTypesTitle: 'Pattern types',
  guidePatternTypesBody:
    'In the straight grid every bead sits above the one below. In the staggered one each row shifts by half a bead, like bricks in a wall.',

  cancel: 'Cancel',
  confirm: 'Confirm',
  close: 'Close',
};
